import { useQuery } from "@apollo/client/react";
import { Button, Grid } from "@mui/material";
import { useState } from "react";
import { UsersListDocument } from "../../../graphql/types";
import type { UsersListQuery, UsersListQueryVariables } from "../../../graphql/types";

import { PlusIcon } from "@phosphor-icons/react/dist/csr/Plus";
import { IfPermission } from "../../../components";
import Permissions from "../../../constants/permissions";
import { AddUser } from "../components/AddUser";
import { UsersTable } from "../components/UsersTable";

const TableAndFilters = () => {
  const { data, loading } = useQuery<UsersListQuery, UsersListQueryVariables>(UsersListDocument, {
    fetchPolicy: "cache-and-network",
  });
  const users = data?.users?.edges?.map((edge) => edge.node) || [];
  return (
    <Grid size={12} sx={{ pt: 4 }}>
      <UsersTable users={users} loading={loading} />
    </Grid>
  );
};

const UsersPage = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <Grid container>
        <Grid sx={{ justifySelf: "flex-end", marginLeft: "auto" }}>
          <IfPermission permission={Permissions.ManageUsers}>
            <Button startIcon={<PlusIcon />} onClick={() => setOpenModal(true)} aria-label="Add user">
              User
            </Button>
          </IfPermission>
        </Grid>
        <TableAndFilters />
      </Grid>
      {openModal ? <AddUser open={openModal} onClose={() => setOpenModal(false)} /> : null}
    </>
  );
};

export { UsersPage };
